<template>
  <div
    :class="['status-wrapper', status['class'], { disabled }]"
    @click="clickStatus()"
  >
    {{ status["text"] }}
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { STATUS } from "../../utils/enum/productStatus";

export default {
  name: "Status",
  props: {
    type: {
      type: String,
      default: STATUS.ACTIVE,
    },
    pid: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
  },
  computed: {
    status() {
      if (!this.groupId && this.type === STATUS.SUSPENDED) {
        return { text: "Eşleşme Bekleyen Ürün", class: "blue" };
      }
      if (this.type === STATUS.ACTIVE)
        return { text: "Onaylı", class: "green" };
      if (this.type === STATUS.SUSPENDED)
        return { text: "Beklemede", class: "blue" };
      if (this.type === STATUS.INAPPROVAL)
        return { text: "Onayınız Gerekiyor", class: "blue" };
      if (this.type === STATUS.INCATALOGAPPROVAL)
        return { text: "Katalog Onayı Bekliyor", class: "blue" };
      if (this.type === STATUS.UNLISTED)
        return { text: "Limit Dışı", class: "gray" };
      if (this.type === STATUS.PROHIBITED)
        return { text: "Yasaklı", class: "red" };
      if (this.type === STATUS.CATALOGREJECTED)
        return { text: "Katalogdan Reddedildi", class: "red" };
      return { text: "", class: "" };
    },
    disabled() {
      return (
        this.type === STATUS.INCATALOGAPPROVAL ||
        this.type === STATUS.CATALOGREJECTED ||
        this.type === STATUS.INAPPROVAL ||
        this.type === STATUS.PROHIBITED ||
        (!this.groupId &&
          this.type !== STATUS.CATALOGREJECTED &&
          this.type !== STATUS.INAPPROVAL)
      );
    },
  },
  methods: {
    ...mapMutations("products", ["SET_SHOW_PRODUCT_STATUS_MODAL"]),
    clickStatus() {
      if (!this.disabled) {
        this.SET_SHOW_PRODUCT_STATUS_MODAL(this.pid);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.status-wrapper {
  display: flex;
  cursor: pointer;
  white-space: nowrap;
  min-width: 116px;
  height: 24px;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 0.5px solid $colorD30;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  align-items: center;
  justify-content: start;

  &.disabled {
    cursor: default;
    opacity: 0.6;
  }

  &::before {
    content: "";
    display: block;
    margin-right: 2px;
  }

  &::after {
    content: "";
    display: block;
    width: 17px;
    height: 16px;
    margin-left: auto;
  }

  &.green {
    background: $colorS05;
    color: $colorS50;

    &::before {
      width: 12px;
      height: 12px;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Ccircle cx='6' cy='6' r='6' fill='%235eba57'/%3E%3Cpath fill-rule='evenodd' d='M8.784 3.739a.6.6 0 0 1 .077.845l-3 3.6a.6.6 0 0 1-.885.04l-1.8-1.8a.6.6 0 0 1 .849-.849L5.36 6.911l2.579-3.095a.6.6 0 0 1 .845-.077z' fill='%23fff'/%3E%3C/svg%3E");
    }

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%23008c20'/%3E%3C/svg%3E");
    }
  }

  &.yellow {
    color: $colorY60;
    background: $colorY05;

    &::before {
      width: 15px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M7.252 2a6 6 0 0 0 0 12 6 6 0 1 0 0-12zm0 1.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6zm.595 1.49a.6.6 0 0 0-1.196.07V8l.005.079a.6.6 0 0 0 .171.345l1.62 1.62.057.05a.6.6 0 0 0 .792-.05l.05-.057a.6.6 0 0 0-.05-.792L7.851 7.751V4.76l-.004-.07z' fill='%23a38712'/%3E%3C/svg%3E");
    }

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%23a38712'/%3E%3C/svg%3E");
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%23a38712'/%3E%3C/svg%3E");
    }
  }

  &.blue{
    color: $colorB50;
    background: $colorB05;

    &::before{
      width: 12px;
      height: 12px;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath d='M6 0a6 6 0 1 1 0 12A6 6 0 1 1 6 0zm0 2.16a.6.6 0 0 0-.6.6V6l.005.079a.6.6 0 0 0 .171.345l1.619 1.62.057.05a.6.6 0 0 0 .792-.05l.05-.057a.6.6 0 0 0-.05-.792L6.6 5.751V2.76l-.004-.069A.6.6 0 0 0 6 2.16z' fill='%234fa4e5'/%3E%3C/svg%3E");
    }
  }

  &.red {
    color: $colorE60;
    background: $colorE05;

    &::before {
      width: 13px;
      height: 12px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='12' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Ccircle cx='6.25' cy='6' r='6' fill='%23d13333'/%3E%3Cpath d='M4.25 6h4' stroke='%23fff' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
    }

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%23d13333'/%3E%3C/svg%3E");
    }
  }

  &.gray {
    color: var(--Neutral---Background-N60, #6b6b6b);
    background: var(--Neutral---Background-N10, #f5f5f5);

    &::before {
      width: 15px;
      height: 16px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M9.878 4.528c.546-.452 1.296.298.844.844l-.048.052L8.099 8l2.575 2.576c.549.549-.233 1.363-.796.896l-.052-.047L7.25 8.849l-2.576 2.575a.6.6 0 0 1-.792.05l-.057-.05a.6.6 0 0 1-.05-.792l.05-.057L6.401 8 3.826 5.424a.6.6 0 0 1-.05-.792l.05-.057a.6.6 0 0 1 .792-.05l.057.05L7.25 7.151l2.576-2.575.052-.048z' fill='%236b6b6b'/%3E%3C/svg%3E");
    }

    &::after {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none' xmlns:v='https://vecta.io/nano'%3E%3Cpath fill-rule='evenodd' d='M12.193 7.334c.26-.26.26-.682 0-.943-.24-.24-.619-.259-.88-.055l-.063.055L8.25 9.39 5.23 6.392c-.24-.24-.618-.259-.88-.055l-.063.055c-.24.24-.259.618-.055.88l.055.063 3.491 3.47c.24.24.618.259.88.056l.063-.056 3.472-3.47z' fill='%236b6b6b'/%3E%3C/svg%3E");
    }
  }
}
</style>
